<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.activities', 2),
                        href: meta.links.activities_index,
                    },
                    {
                        name: activity.title,
                        href: null,
                    },
                    {
                        name: $tc('messages.questions', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <PracticeModeInfo :practice-mode="meta.info.practice_mode" />

        <QuizForm :activity="activity" :questions="questions" :options="options" :meta="meta" />
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import QuizForm from '@/Pages/Teacher/Quiz/Activity/Preview/QuizForm.vue';
import PracticeModeInfo from '../../../../components/PracticeModeInfo.vue';

export default {
    components: {
        PracticeModeInfo,
        QuizForm,
        PanelPage,
    },
    layout: Layout,
    name: 'Create',
    props: ['meta', 'options', 'questions', 'activity'],
};
</script>
